import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 22.5a4.75 4.75 0 0 1 3.5 -3.5a4.75 4.75 0 0 1 -3.5 -3.5a4.75 4.75 0 0 1 -3.5 3.5a4.75 4.75 0 0 1 3.5 3.5","key":"svg-0"}],["path",{"d":"M11.5 19h-6.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5","key":"svg-1"}],["path",{"d":"M3 7l9 6l9 -6","key":"svg-2"}]]

const IconMailSpark = createReactComponent('outline', 'mail-spark', 'MailSpark', __iconNode);

export default IconMailSpark;